import React, { useContext } from 'react';
import { ArticleContext } from '~/context/articleContext';
import * as articleHelper from '~/helpers/article';

const CategoriesList = () => {
  const { article } = useContext(ArticleContext);
  const articles = articleHelper.getSortedArticlesByCategory(article);

  return (
    <ul className="list__card">
      {articles.map((art, i) => (
        <li key={i} className="list__card-element">
          <a href={art.path}>
            <h6 className="list__card-header">{art.title}</h6>
            <p className="list__card-conent">{art.description}</p>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default CategoriesList;
